import axios from 'axios';
import pako from 'pako';
import { get, patch, put, post, del } from '../libs/api/apiConnector';
import apiRoutes from '../helpers/apiRoutes';
import replaceParameters from '../helpers/parameterHelper';
import { showSubscriptionCards } from '../store/actions/profile';
import common from '../helpers/common';
import responseCodes from '../helpers/responseCodes';

let cancelTokenSource;


export const getFolderData = async (stateIds, source = null) => {
  try {
    const config = {};
    const params = { stateIds }
    if (source) {
      params.source = source
    }
    const { data } = await get(apiRoutes.REGULATIONS.FOLDER, { params, config });
    return data;
  } catch (error) {
    console.error(`error ${error}`);
    return error;
  }
};

export const getParentCitationData = async (stateIds, folderId, queryParamString=null) => {
  try {
    let url = replaceParameters(apiRoutes.REGULATIONS.FOLDER_PARENT_CITATIONS, { folderId });
    if(queryParamString) {
      url = `${url}?${queryParamString}`;
    }
    const config = {};
    const params = { stateIds }
    const { data } = await get(url, { params, config });
    return data;
  } catch (error) {
    console.error(`error ${error}`);
    return error;
  }
};

export const getRegTreeData = async (id, isNotSearch=false, queryParamString=null, dispatch) => {
  try {
    if (cancelTokenSource) {
      cancelTokenSource.cancel('Canceled due to new request.');
    }
    cancelTokenSource = axios.CancelToken.source();

    let url = replaceParameters(isNotSearch ? apiRoutes.REGULATIONS.REGULATIONS_CTREE : apiRoutes.REGULATIONS.REGULATIONS_TREE, { id });
    if(queryParamString) {
      url = `${url}?${queryParamString}`;
    }
    const config = {
      cancelToken: cancelTokenSource.token,
    };
    const { data } = await get(url, { config });
    dispatch(showSubscriptionCards(common.REG_TABS[0].id, false))
    return data;
  } catch (error) {
    if(error?.response?.status === responseCodes.ERROR.PAYMENT_REQUIRED.CODE) {
      dispatch(showSubscriptionCards(common.REG_TABS[0].id, true))
    }
    console.error(`error ${error}`);
    return error;
  }
};

export const getDefinitionData = async (definition_id) => {
  try {
    const config = {};
    const url = replaceParameters(apiRoutes.REGULATIONS.DEFINITION, { definition_id });
    const { data } = await get(url, { config });
    return data.data ?? null
  } catch (error) {
    console.error(`error ${error}`);
    return null;
  }
};

export const updateUserDetails = async (body, id) => {
  try {
    const url = replaceParameters(apiRoutes.USER.UPDATE_USER_PROFILE_DETAILS, { id });
    const config = {
      detachAccessToken: true,
      detachRoleToken: true,
    };
    const { data } = await patch(url, body, { config });
    return data;
  } catch (error) {
    console.error(`error ${error}`);
    return error.response.data;
  }
};

export const getStateList = async (queryParam=null) => {
  try {
    let url = apiRoutes.REGULATIONS.GET_STATES;
    if(queryParam) {
      url = `${url}?${queryParam}`;
    }
    const { data } = await get(url);
    return data
  } catch (error) {
    console.error(`get-state-list ${error}`)
    return error
  }
}

export const getAllStateList = async () => {
  try {
    const { data } = await get(apiRoutes.REGULATIONS.GET_ALL_STATES);
    return data
  } catch (error) {
    console.error(`get-state-list ${error}`)
    return error
  }
}

export const updateRegulationData = async (id, body) => {
  try {
    const url = replaceParameters(apiRoutes.REGULATIONS.REGULATION_UPDATE, { id });
    const { data } = await put(url, body);
    return data;
  } catch (error) {
    console.error(`error ${error}`);
    return error.response.data;
  }
};

export const updateHempRegulationData = async (id, body, queryParam=null) => {
  try {
    let url = replaceParameters(apiRoutes.REGULATIONS.HEMP_REGULATION_UPDATE, { id });
    if(queryParam) {
      url = `${url}?${queryParam}`;
    }
    const { data } = await put(url, body);
    return data;
  } catch (error) {
    console.error(`error ${error}`);
    return error.response.data;
  }
};

export const addChildHempRegulationData = async (id, body, queryParam=null) => {
  try {
    let url = replaceParameters(apiRoutes.REGULATIONS.HEMP_REGULATION_ADD_CHILD, { id });

    if(queryParam) {
      url = `${url}?${queryParam}`;
    }
    const { data } = await post(url, body);
    return data;
  } catch (error) {
    console.error(`error ${error}`);
    return error.response.data;
  }
};

export const deleteHempRegulationData = async (sorceId, id, queryParam=null) => {
  try {
    let url = replaceParameters(apiRoutes.REGULATIONS.HEMP_REGULATION_DELETE, { sorceId, id });
    if(queryParam) {
      url = `${url}?${queryParam}`;
    }

    const response = await del(url);
    return response;
  } catch (error) {
    console.error(`error ${error}`);
    return error.response.data;
  }
};

export const updateHempRegulationTree = async (sorceId, data, queryParam=null) => {
  try {
    let url = replaceParameters(apiRoutes.REGULATIONS.HEMP_TREE_UPDATE, { sorceId });
    if(queryParam) {
      url = `${url}?${queryParam}`;
    }

    const jsonString = JSON.stringify(data);
    const compressed = pako.gzip(jsonString);
    const config ={
      headers: {
        'Content-Type': 'application/json',
        'Content-Encoding': 'gzip'
      }
    };

    // const response = await post(url, data);
    const response = await post(url, compressed, config);
    return response;
  } catch (error) {
    console.error(`error ${error}`);
    return error.response.data;
  }
};

export const getHempRegulationData = async (requestData, dispatch) => {
  try {
    if (cancelTokenSource) {
      cancelTokenSource.cancel('Canceled due to new request.');
    }
    cancelTokenSource = axios.CancelToken.source();
    let url = apiRoutes.REGULATIONS.HEMP;
    if(requestData.fileId) {
      url = `${url}/${requestData.fileId}`;
    }
    const config = {
      cancelToken: cancelTokenSource.token,
    };
    const params = {
      state_ids: requestData.state_ids
    }
    const { data } = await get(url, { params, config });
    dispatch(showSubscriptionCards(common.REG_TABS[1].id, false))
    return data;
  } catch (error) {
    if(error?.response?.status === responseCodes.ERROR.PAYMENT_REQUIRED.CODE) {
      dispatch(showSubscriptionCards(common.REG_TABS[1].id, true))
    }
    console.error(`error ${error}`);
    return error.response.data;
  }
};

export const getHempTreeData = async (id, dispatch=null, queryParam=null) => {
  try {
    if (cancelTokenSource) {
      cancelTokenSource.cancel('Canceled due to new request.');
    }
    cancelTokenSource = axios.CancelToken.source();

    let url = replaceParameters( apiRoutes.REGULATIONS.HEMP_CTREE , { id });
    const config = {
      cancelToken: cancelTokenSource.token,
    };

    if(queryParam) {
      url = `${url}?${queryParam}`;
    }
    const { data } = await get(url, { config });
    if(dispatch) dispatch(showSubscriptionCards(common.REG_TABS[1].id, false))
    return data;
  } catch (error) {
    if(error?.response?.status === responseCodes.ERROR.PAYMENT_REQUIRED.CODE && dispatch) {
      dispatch(showSubscriptionCards(common.REG_TABS[1].id, true))
    }
    console.error(`error ${error}`);
    return error;
  }
};